import { createAuthClient } from 'better-auth/react';

// In development, the Vite proxy forwards /api requests to the backend
// so auth cookies stay on the same origin (localhost:3000).
// Using an empty baseURL makes requests relative to the current origin,
// which the proxy then routes to the backend.
export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL || '',
  fetchOptions: {
    credentials: 'include',
  },
});

export const { signIn, signUp, signOut, useSession } = authClient;
